export const SECTOR_LENGTH = 2.512;
export const CIRCLE_LENGTH = 251.2;
